var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"box-loading d-flex justify-content-center"},[_vm._m(0)]):_vm._e(),_c('div',{ref:"viewer",attrs:{"id":"webviewer"}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading f30 py-2"},[_c('i',{staticClass:"bx bx-loader-circle bx-spin bx-rotate-90 fz50"})])
}]

export { render, staticRenderFns }